import * as z from "zod";

export const updateLinearTicketAssignee = {
  name: "updateLinearTicketAssignee" as const,
  input: z.object({
    linearTicketId: z.string(),
    assigneeId: z.string().nullable(),
  }),
  output: z.object({
    success: z.boolean(),
    newAssigneeName: z.string().nullable(),
    newAssigneeId: z.string().nullable(),
    newAssigneeAvatarUrl: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
